module.exports = __webpack_public_path__ + "img/badge_gray_hs-military.466b791f.svg";